<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-user-edit"></i>
          {{ $t("public.views.Pages.Share.title") }}
          <span v-if="patient !== null && patient.name">
            - {{ patient.name }} {{ patient.lastname }} (
            {{ patient.document }} )
          </span>
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mr-2" right variant="success" @click="openModal('CREATE', null)">{{
          $t("public.views.Pages.Share.btnCreate")
        }}
        </b-button>
        <b-button v-if="patient !== null && patient.name" right variant="primary" @click="backContacts">{{
          $t("public.views.Pages.Share.btnBack")
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <div class="text-right"></div>
        <v-card-title>
          <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line>
            <template slot="label">
              <div class="search-datatable">
                <i class="fas fa-search fa-fw"></i>
                {{ $t("public.views.Pages.Share.search") }}
              </div>
            </template>
          </v-text-field>
        </v-card-title>
        <v-data-table :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'fas fa-arrow-left',
          lastIcon: 'fas fa-arrow-right',
          prevIcon: 'fas fa-minus',
          nextIcon: 'fas fa-plus',
          'items-per-page-options': [10, 25, 50],
        }" :headers="headers" :items="shares" :options.sync="pagination" :search="search" :server-items-length="total"
          item-key="id">
          <template v-slot:item.createdAt="{ item }">
            <div v-if="item.createdAt">
              {{ item.createdAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
            </div>
          </template>
          <template v-slot:item.uuid="{ item }">
            <div class="div-table-data">
              <button :id="'btnUpdate' + item.id" class="item" v-on:click="openModal('UPDATE', item.id)">
                <i class="ri-refresh-line"></i>
              </button>
              <b-popover :target="'btnUpdate' + item.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t("public.views.Pages.Share.btnUpdate")
                }}
                </template>
              </b-popover>

              <button :id="'btnDownload' + item.id" class="item" @click="downloadFile(item.uuid, item.filename)">
                <i class="ri-file-download-line text-black"></i>
              </button>
              <b-popover :target="'btnDownload' + item.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t("public.views.Pages.Share.btnDownload")
                }}
                </template>
              </b-popover>
            </div>
          </template>
          <template v-slot:item.category="{ item }">
            {{ $t("public.views.Pages.Share.categories." + item.category) }}
          </template>

          <template v-slot:item.filename="{ item }">
            <div v-if="item.filename">
              <i v-if="
                item.filename
                  .substring(
                    item.filename.lastIndexOf('.') + 1,
                    item.filename.length
                  )
                  .toLowerCase() === 'mp4'
              " class="fas fa-file-video"></i>
              <i v-else-if="
                item.filename
                  .substring(
                    item.filename.lastIndexOf('.') + 1,
                    item.filename.length
                  )
                  .toLowerCase() === 'pdf'
              " class="fas fa-file-pdf"></i>
              <i v-else-if="
                item.filename
                  .substring(
                    item.filename.lastIndexOf('.') + 1,
                    item.filename.length
                  )
                  .toLowerCase() === 'png' ||
                item.filename
                  .substring(
                    item.filename.lastIndexOf('.') + 1,
                    item.filename.length
                  )
                  .toLowerCase() === 'jpg' ||
                item.filename
                  .substring(
                    item.filename.lastIndexOf('.') + 1,
                    item.filename.length
                  )
                  .toLowerCase() === 'jpeg' ||
                item.filename
                  .substring(
                    item.filename.lastIndexOf('.') + 1,
                    item.filename.length
                  )
                  .toLowerCase() === 'gif'
              " class="fas fa-file-image"></i>
              <i v-else-if="
                item.filename
                  .substring(
                    item.filename.lastIndexOf('.') + 1,
                    item.filename.length
                  )
                  .toLowerCase() === 'word'
              " class="fas fa-file-word"></i>
              <i v-else-if="
                item.filename
                  .substring(
                    item.filename.lastIndexOf('.') + 1,
                    item.filename.length
                  )
                  .toLowerCase() === 'xls'
              " class="fas fa-file-excel"></i>
              <i v-else-if="
                item.filename
                  .substring(
                    item.filename.lastIndexOf('.') + 1,
                    item.filename.length
                  )
                  .toLowerCase() === 'txt'
              " class="fas fa-file-alt"></i>
              <i v-else class="far fa-file"></i>
              {{ item.filename }}
            </div>
          </template>
        </v-data-table>
      </template>
    </iq-card>

    <b-modal id="modal-create" cancel-title="Cerrar" centered @ok="saveFormStep1">
      <template #modal-title>
        <div v-if="action === 'CREATE'">
          {{ $t("public.views.Pages.Share.modalCreate.title") }}
        </div>
        <div v-if="action === 'UPDATE'">
          {{ $t("public.views.Pages.Share.modalCreate.titleUpdate") }}
        </div>
      </template>
      <template #modal-ok>{{
        $t("public.views.Pages.Share.modalCreate.save")
      }}
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Share.modalCreate.close")
      }}
      </template>
      <b-form-group label-for="organization">
        <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.organization") }}: *
        </template>
        <b-avatar class="mr-3" square v-bind:src="selectedOrganization.logoUrl + '/' + getAuthentication()"></b-avatar>
        <span class="mr-auto title-typography-color">{{
          selectedOrganization.name
        }}</span>
      </b-form-group>
      <b-form-group label-for="professional">
        <template slot="label">
          {{ $t("public.views.Pages.Patient.Schedule.professional") }}: *
        </template>

        <multiselect v-model="professional" :multiple="false" :options="professionalSelect" label="text" track-by="value"
          v-bind:deselectGroupLabel="
            $t(
              'public.views.Pages.Patient.Schedule.multiselect.deselectGroupLabel'
            )
          " v-bind:deselectLabel="
  $t('public.views.Pages.Patient.Schedule.multiselect.deselectLabel')
" v-bind:placeholder="
  $t('public.views.Pages.Patient.Schedule.multiselect.placeholder2')
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Patient.Schedule.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t('public.views.Pages.Patient.Schedule.multiselect.selectLabel')
" v-bind:selectedLabel="
  $t('public.views.Pages.Patient.Schedule.multiselect.selectedLabel')
">
          <template slot="option" slot-scope="props">
            <b-list-group-item class="d-flex align-items-center">
              <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
              <span class="mr-auto title-typography-color">{{
                props.option.text
              }}</span>
            </b-list-group-item>
          </template>
          <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span class="option__desc"><span
                class="option__title">
                <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar><span
                  class="mr-auto title-typography-color">{{
                    props.option.text
                  }}</span>
              </span></span></template>
          <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
              class="multiselect__single">{{ values.length }}
              {{
                $t("public.views.Pages.Patient.Schedule.selectedProfessionals")
              }}</span></template>
        </multiselect>
      </b-form-group>
      <b-form-group label-for="name">
        <template slot="label">{{ $t("public.views.Pages.Share.name") }}: *
        </template>
        <b-form-input id="name" v-model="name" :disabled="disabled" type="text" v-bind:class="{
          'text-danger': isFormNameErrors,
          'is-invalid': isFormNameErrors,
        }" @blur="checkName(name)"></b-form-input>
        <ul v-if="isFormNameErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('name')" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="category">
        <template slot="label">{{ $t("public.views.Pages.Share.category") }}: *
        </template>
        <b-select v-model="category" :disabled="disabled" :options="categorySelect" type="text" v-bind:class="{
          'text-danger': isFormCategoryErrors,
          'is-invalid': isFormCategoryErrors,
        }" @blur="checkCategory(name)"></b-select>
        <ul v-if="isFormNameErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('category')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="file">
        <template slot="label">{{ $t("public.views.Pages.Share.file") }}: *
        </template>
        <vue-dropzone id="file" :options="dropzoneOptions" @vdropzone-success="vdropzoneSuccess"></vue-dropzone>
        <a v-if="fileData && fileName" :download="fileName" :href="'data:application/octet-stream;base64,' + fileData">
          <i class="fas fa-download fa-fw"></i>{{ fileName }}
        </a>
        <ul v-if="isFormFileErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('file')" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../config/pluginInit";

import { mapGetters } from "vuex";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import { saveAs } from "file-saver";

import validator from "vue-m-validator";

import utilsService from "../../../services/utils";
import patientService from "../../../services/patient";
import shareService from "../../../services/share";
import userService from "../../../services/user";
import organizationService from "../../../services/organization";

import CategoryShare from "../../../json/CategoryShare";

export default {
  name: "Share",
  components: {
    "vue-dropzone": vue2Dropzone,
    Multiselect,
  },
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAllShares();
        }
        this.start = true;
      },
    },
  },
  computed: {
    isFormFileErrors() {
      let errors = this.validatorStep1.getErrors("file");
      return errors && errors.length > 0;
    },
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormCategoryErrors() {
      let errors = this.validatorStep1.getErrors("category");
      return errors && errors.length > 0;
    },
    ...mapGetters({
      selectedOrganization: "Setting/organizationState",
    }),
  },
  data: () => ({
    total: 0,
    pagination: {},
    action: "",
    search: "",
    uuid: "",
    text: "",
    file: "",
    nameFile: "",
    professional: {},

    professionalSelect: [],
    //Form image
    dropzoneOptions: {
      url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
      thumbnailWidth: 200,
      maxFilesize: 2,
      addRemoveLinks: true,
      maxFiles: 1,
      dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
    },

    headers: [
      {
        text: "Fecha de creación",
        align: "start",
        value: "createdAt",
      },
      {
        text: "Título",
        value: "name",
      },
      {
        text: "Categoría",
        value: "category",
      },
      {
        text: "Nombre del archivo",
        value: "filename",
      },
      { text: "", value: "uuid" },
    ],
    shares: [],
    usersSelect: [],

    validatorStep1: validator,
    //Form create new share
    id: "",
    userFrom: localStorage.getItem("userId"),
    name: "",
    fileUUID: "",
    fileName: "",
    fileData: "",
    category: "",

    disabled: false,

    categorySelect: CategoryShare,
    //Patient
    patient: {},
  }),
  mounted() {
    xray.index();
    this.findProfessionalsOrganization();
    this.getAllShares();
    if (this.$route.query.patient) {
      this.getPatient(this.$route.query.patient);
    }
    utilsService.auditActivity({ action: "VIEW", module: "PATIENT_SHARE", info: "" });
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    findProfessionalsOrganization() {
      let self = this;

      organizationService
        .getAllProfessionalsByIdActive(localStorage.getItem("organizationId"))
        .then((response) => {
          if (response) {
            if (response.data) {
              //Professional
              let combo = [];
              response.data.forEach(function (item) {
                combo.push({
                  value: item.id,
                  text: item.name + " " + item.lastname,
                  avatar: item.avatarUrl
                    ? item.avatarUrl +
                    "/" +
                    localStorage.getItem("authorization")
                    : "",
                });

                self.professionalSelect = combo;
              });
            }
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllProfessionalsByIdActive",
            module: "view-pages-patient-share",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId")
            })
          });
        });
    },
    downloadFile(uuid, filename) {
      let self = this;
      this.$awn.asyncBlock(
        utilsService.getFile(uuid),
        (response) => {
          if (response) {
            var byteCharacters = atob(response.data.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/octet-stream;base64",
              name: "prueba",
            });

            saveAs(file, filename);
          }
        },
        (error) => {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t("public.views.Pages.Share.notification.error"),
            text: this.$i18n.t(
              "public.views.Pages.Share.notification.descErrorDwn"
            ),
            type: "error",
          });
          utilsService.auditErrorFrontent({
            info: "utilsService.getFile",
            module: "view-pages-patient-share",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              uuid: uuid
            })
          });
        },
        ""
      );
    },
    openModal(action, id) {
      this.action = action;

      this.cleanAll();
      this.$bvModal.show("modal-create");

      if (this.action === "UPDATE") {
        this.getShare(id);
      }
    },
    backContacts() {
      this.$router.push({
        name: "auth.professional.contact.contacts",
      });
    },
    async getPatient(id) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.get(id),
        (response) => {
          if (response) {
            self.patient = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.get",
            module: "view-pages-patient-share",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        }
      );
    },
    //Check if patient is in paths
    notFirst() {
      this.isFirstRun = false;
    },
    saveFormStep1(evt) {
      evt.preventDefault();
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        //Call service to store data
        if (this.action === "CREATE") {
          this.create();
        }
        if (this.action === "UPDATE") {
          this.update();
        }

        //    this.$bvModal.hide("modal-create");
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t("public.views.Pages.Share.notification.error"),
          text: this.$i18n.t(
            "public.views.Pages.Share.notification.descErrorStep1"
          ),
          type: "error",
        });
      }
    },
    checkFormStep1() {
      this.checkName(this.name);
      this.checkFile(this.fileUUID);
      this.checkCategory(this.category);
    },
    cleanAll() {
      this.name = "";
      this.fileUUID = "";
      this.category = "";
      this.fileUUID = "";
      this.fileName = "";
      this.fileData = "";
    },

    create() {
      let self = this;

      let model = {
        usersTo: [this.professional.value],
        userFrom: this.userFrom,
        name: this.name,
        category: this.category,
        fileUUID: this.fileUUID,
        organizationId: localStorage.getItem("organizationId"),
      };

      this.$awn.asyncBlock(
        shareService.create(model),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_SHARE", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Share.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Share.notification.descCreated"
              ),
              type: "success",
            });
            self.$bvModal.hide("modal-create");
            self.getAllShares();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "shareService.create",
            module: "view-pages-patient-share",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              model: model
            })
          });
        },
        " "
      );
    },
    update() {
      let self = this;

      let model = {
        id: this.id,
        userFrom: this.userFrom,
        name: this.name,
        category: this.category,
        fileUUID: this.fileUUID,
      };

      this.$awn.asyncBlock(
        shareService.update(model),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PATIENT_SHARE", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Share.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Share.notification.descRefresh"
              ),
              type: "success",
            });
            self.$bvModal.hide("modal-create");
            self.getAllShares();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "shareService.update",
            module: "view-pages-patient-share",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              model: model
            })
          });
        },
        " "
      );
    },
    getShare(id) {
      let self = this;
      this.$awn.asyncBlock(
        shareService.get(id),
        (response) => {
          if (response) {
            self.id = response.data.id;
            self.userFrom = response.data.from;
            self.name = response.data.name;
            self.category = response.data.category;
            if (response.data.file) {
              self.fileUUID = response.data.file.uuid.replace("/", "");
              self.fileName = response.data.file.name;
              self.fileData = response.data.file.data;
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "shareService.get",
            module: "view-pages-patient-share",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    async getAllShares() {
      let self = this;
      this.$awn.asyncBlock(
        shareService.getAll(
          this.pagination.page - 1,
          this.pagination.itemsPerPage
        ),
        (response) => {
          if (response) {
            self.shares = response.data.content;
            self.total = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "shareService.getAll",
            module: "view-pages-patient-share",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage
            })
          });
        },
        " "
      );
    },
    async getAllUser() {
      let self = this;
      this.$awn.asyncBlock(
        userService.getAll(),
        (response) => {
          if (response) {
            let combo = [];
            response.data.forEach(function (item) {
              if (item.id != localStorage.getItem("userId")) {
                combo.push({
                  value: item.id,
                  text:
                    item.name !== null
                      ? item.name
                      : "" + " " + item.lastname !== null
                        ? item.lastname
                        : "",
                });
              }
            });
            self.usersSelect = combo;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "userService.getAll",
            module: "view-pages-patient-share",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        },
        " "
      );
    },
    vdropzoneSuccess: function (file, response) {
      this.fileUUID = response.uuid;
      this.fileName = response.name;
      this.getFile(this.fileUUID);
    },
    getFile(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.fileData = response.data.data;
          }
        })
        .catch(function (error) {
          utilsService.auditErrorFrontent({
            info: "utilsService.getFile",
            module: "view-pages-patient-share",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              uuid: uuid
            })
          });
        });
    },
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t("public.views.Pages.Share.errors.erName"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkCategory(_category) {
      const CATEGORY = _category.trim();
      const RULE_1 = {
        expression: !CATEGORY || CATEGORY === "",
        name: "category",
        msg: this.$i18n.t("public.views.Pages.Share.errors.erCategory"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkFile(_file) {
      const FILE = _file.trim();
      const RULE_1 = {
        expression: !FILE || FILE === "",
        name: "file",
        msg: this.$i18n.t("public.views.Pages.Share.errors.erFile"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
  },
};
</script>

